<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col cols="9" class="pa-2">
                    <v-card >
                        <v-toolbar dense>
                        <v-icon  left color="primary">mdi-account-multiple</v-icon> MANAGE CUSTOMERS  
                        <v-spacer></v-spacer>
                       <span style="width: 290px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                       </span>
                        <v-icon right color="success" large @click="customer={}, state='new', form=true">mdi-plus-box</v-icon> 
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-4"
                                dense
                                :headers="headers"
                                disable-sort
                                :search="search"
                                :items="CUSTOMERS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                           <td>
                                              <v-icon small left color="warning" large @click="customer=item, state='update', form=true">mdi-pencil</v-icon>
                                             {{ item.area_code }}</td>
                                           <td>{{ item.trade_name }}</td>
                                            <td>{{ item.type_name }}</td>
                                            <td><div class="pa-2">
                                                {{ item.lastname }}, {{ item.firstname }} {{ item.middle }}<br />
                                                  <small><v-icon x-small>mdi-phone</v-icon> {{ item.contact_number }} | <v-icon x-small>mdi-email</v-icon> {{ item.email?item.email:'----' }}</small>
                                                </div>
                                            </td>
                                            <td width="100px"><v-chip small text color="success"> {{ item.status }} </v-chip> </td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
            </v-col>

             <v-col cols="3" class="pa-2">
                    <v-card>
                        <v-toolbar dense>
                        <v-icon  left color="primary">mdi-account-multiple</v-icon> TYPES
                        <v-spacer></v-spacer>
                       
                        <v-icon right color="success" large @click="customertype={}, state='new', typeform=true">mdi-plus-box</v-icon> 
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-4"
                                dense
                                :headers="types_header"
                                :search="search"
                                hide-default-footer
                                disable-pagination
                                :items="TYPES"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                           <td><v-icon small left color="warning" @click="customertype=item, state='update', typeform=true">mdi-pencil</v-icon> {{ item.name }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
    <va-customer-form :show="form" :item="customer"  :state="state" @DialogEvent="formEvent" />
    <va-text-edit-form :state="state" :show="typeform" :data="customertype.name"  @DialogEvent="typeEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        typeform:false,
        customertype:{},
        textedit:'',
        form: false,
        state: 'new',
        customer: {},
        search:'',
        customers:[],
        types_header:[
           { text: 'TYPE', value: 'type' },
        ],
       headers: [
          {
            text: 'ROUTE CODE:',
            value: 'area_code'
          },
          { text: 'TRADE NAME', value: 'trade_name' },
          { text: 'TYPE', value: 'type_name' },
          { text: 'CONTACT ', value: 'firstname' },
          { text: 'STATUS', value: 'status' }
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.GET_CUSTOMERS('active')
          this.GET_CUSTOMER_TYPES()
          this.GET_SETTINGS()
          this.GET_PRODUCTS()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      CUSTOMERS(){
        return this.$store.state.customers
      },
      TYPES() {
        return this.$store.state.customertypes
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(){
          this.form = false
        this.GET_CUSTOMERS('active')
      },
      typeEvent(data){
          this.typeform = false
          if(data.action != 'close') {
            this.customertype.name=data.text
              this.SaveType()
          }
      },
      SaveType() {
           this.$http.post(this.state=='new'?'customer/add_type':'customer/update_type', this.customertype).then(response => {
                response.data.status?this.VA_ALERT('success',response.data.message):this.VA_ALERT('error',response.data.message)
                 this.GET_CUSTOMER_TYPES()
              }).catch(e => {
                console.log(e.data)
            })
      }
    }
  }
</script>